<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link v-if="SETTING['logo']" class="navbar-brand" to="#">
      <img :src="SETTING['logo']" alt="Logo" class="brand-logo">
    </b-link>
    <b-navbar-nav class="ml-auto">
      <HeaderDropdownAccnt/>&nbsp;&nbsp;&nbsp;&nbsp;
    </b-navbar-nav>
  </header>
</template>

<script>
import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'

export default {
  name: 'c-header',
  components: {
    HeaderDropdownAccnt
  },
  data: () => {
    return {
      username: ''
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }
}
</script>

<style lang="scss">
.brand-logo{
  object-fit: contain;
  width: 100%;
  height: 100%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue